var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon16BlogEmojiSmiling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm2 0a8 8 0 1 1 16 0 8 8 0 0 1-16 0zm5 1a1 1 0 1 0-2 0 5 5 0 0 0 10 0 1 1 0 1 0-2 0 3 3 0 1 1-6 0zm-1-3a1 1 0 0 0 1-1 1 1 0 0 0 2 0 2 2 0 1 0-4 0 1 1 0 0 0 1 1zm7-1a1 1 0 1 1-2 0 2 2 0 1 1 4 0 1 1 0 1 1-2 0z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0yIDEyYTEwIDEwIDAgMSAwIDIwIDAgMTAgMTAgMCAwIDAtMjAgMHptMiAwYTggOCAwIDEgMSAxNiAwIDggOCAwIDAgMS0xNiAwem01IDFhMSAxIDAgMSAwLTIgMCA1IDUgMCAwIDAgMTAgMCAxIDEgMCAxIDAtMiAwIDMgMyAwIDEgMS02IDB6bS0xLTNhMSAxIDAgMCAwIDEtMSAxIDEgMCAwIDAgMiAwIDIgMiAwIDEgMC00IDAgMSAxIDAgMCAwIDEgMXptNy0xYTEgMSAwIDEgMS0yIDAgMiAyIDAgMSAxIDQgMCAxIDEgMCAxIDEtMiAweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+DQo8L3N2Zz4NCg==";
export { SvgIcon16BlogEmojiSmiling as ReactComponent };